var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body"},[_c('div',[_c('themed-table',{attrs:{"headers":this.bedManagerService.packages.headers,"data":_vm.transformedData,"pagination":{
                perPage: this.bedManagerService.packages.query.limit,
                total: this.bedManagerService.packages.total
            },"sortingEnabled":true,"filteringEnabled":false,"paginationEnabled":this.bedManagerService.packages.total > this.bedManagerService.packages.query.limit,"addItem":{ label: 'Package', element: _vm.CreatePackages }},on:{"paginationChange":(event) => {
                this.bedManagerService.packages.query.skip = this.bedManagerService.packages.query.limit * (event.page - 1);
                this.bedManagerService.packages.query = {...this.bedManagerService.packages.query};
            },"searchChange":(event) => {
                const query = this.bedManagerService.packages.query;
                query.skip = 0; // Resets skip as the search params change
                Object.keys(event).forEach((key) => {
                    if (event[key]) query[key] = event[key];
                    else delete query[key];
                })
                this.bedManagerService.packages.query = {...query};
            },"sortingChange":(event) => {
              if (event === 'delete') {
                delete this.bedManagerService.packages.query.sortProperty;
                delete this.bedManagerService.packages.query.sortDirection;
                this.bedManagerService.packages.query = { ...this.bedManagerService.packages.query };
              } else {
                this.bedManagerService.packages.query = { ...this.bedManagerService.packages.query, sortProperty: event.type, sortDirection: event.direction };
              }
            }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }